import { type UseQueryResult, useQuery } from '@tanstack/react-query';
import api from '@/axios';
import { GET_PRODUCTION_DECLARATION_MATERIAL_PRODUCTS_KEY } from '@/keys';
import type { ProductionDeclarationMaterialProduct } from '@/types/core/purchase-order/production-declaration-material-product';

async function getProductionDeclarationMaterialProducts(
  productionDeclarationId: string,
  materialId: string,
  options?: { token?: string },
): Promise<ProductionDeclarationMaterialProduct[]> {
  const response = await api.get<ProductionDeclarationMaterialProduct[]>(
    `/production-declarations/${productionDeclarationId}/materials/${materialId}/products`,
    {
      params: options?.token ? { token: options.token } : undefined,
    },
  );

  return response.data;
}

export function useGetProductionDeclarationMaterialProducts(
  productionDeclarationId: string,
  materialId: string,
  token: string | undefined,
): UseQueryResult<ProductionDeclarationMaterialProduct[], Error> {
  return useQuery({
    queryKey: [
      ...GET_PRODUCTION_DECLARATION_MATERIAL_PRODUCTS_KEY,
      productionDeclarationId,
      materialId,
      token ?? '',
    ],
    queryFn: async () =>
      await getProductionDeclarationMaterialProducts(
        productionDeclarationId,
        materialId,
        {
          token,
        },
      ),
    enabled: Boolean(productionDeclarationId && materialId),
  });
}
